import { render } from "./menu1.vue?vue&type=template&id=6390f987"
import script from "./menu1.vue?vue&type=script&lang=ts"
export * from "./menu1.vue?vue&type=script&lang=ts"
script.render = render

export default script